import airtableProvider from "../../providers/prod/airtable";
import {
	AddOn,
	AddOnPermissionType,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
} from "../../../../index";

const a001AddOn = new AddOn({
  internalId: "a001",
  externalId: "pro_01htwbb4d8ws3kw46ch75s99vy",
  shortName: "Airtable rename attachments",
  longName: "Airtable rename attachments",
  shortDescription: "Rename attachments in bulk with a single click",
  longDescription:
    "* Rename attachments in table view with a single click.\n* Use advanced formulas to compose the perfect file name for the attached file. The formula supports using values from other cells, the attachment index, and the number of attached files in the cell.\n* Take a look at some examples in our documentation.\n* This extension works with any file type and for multiple attachments in a single cell.\n* You have full control! The files are renamed locally on your device and aren't sent to our servers. So your files and formula are kept private.",
  type: AddOnType.APP_EXTENSION,
  iconAsset: Asset.image(
    "https://storage.googleapis.com/cdn.version2.io/add-ons/a001/icons/a001_icon_rounded.png"
  ),
  coverAsset: Asset.image(
    "https://storage.googleapis.com/cdn.version2.io/add-ons/a001/assets/background1.png"
  ),
  previewAssets: [
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a001/screenshots/a001_screenshot_1.png"
    ),
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a001/screenshots/a001_screenshot_2.png"
    ),
  ],
  docsUrl: "https://docs.version2.io/2yBk3DCZZawB6CXhr",
  providersIds: [airtableProvider._.id],
  status: AddOnStatus.ACTIVE,
  plans: [
    new AddOnPlan({
      billingCycle: BillingCycle.yearly(),
      internalId: "a001_p001",
      externalId: "pri_01htwbekg3g1z055gjqfnyxrgs",
      prices: [new Price({ currency: Currency.USD, amount: 14 })],
    }),
    new AddOnPlan({
      billingCycle: BillingCycle.monthly(),
      internalId: "a001_p002",
      externalId: "pri_01htwbfsq7s8vw7b2j22nrcj9y",
      prices: [new Price({ currency: Currency.USD, amount: 2 })],
    }),
  ],
  settingsConfig: [],
  highlightFeatures: [
    new HighlightFeature({
      title: "Any file type",
      description:
        "Works with any file type and for multiple attachments in a single cell.",
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/file-text.svg",
    }),
    new HighlightFeature({
      title: "Live preview",
      description: "Preview the new file name before renaming the files.",
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/eye.svg",
    }),
    new HighlightFeature({
      title: "Advanced formulas",
      description:
        "Use advanced formulas to compose the perfect file name for the attached file.",
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/filter.svg",
    }),
    new HighlightFeature({
      title: "Local processing",
      description:
        "The files are renamed locally on your device and aren't sent to our servers, so your files are kept private.",
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/safety.svg",
    }),
  ],
  allowedPermissionTypes: [
    AddOnPermissionType.AIRTABLE_ACCOUNT,
		AddOnPermissionType.AIRTABLE_ACCOUNT_INVITE,
    AddOnPermissionType.AIRTABLE_BASE,
		AddOnPermissionType.AIRTABLE_SHARED,
  ],
});

export default a001AddOn;
